<template>
  <div>
    <v-card
      :style="[
        $vuetify.breakpoint.smAndDown
          ? { 'min-height': '100vh', 'background-color': '#f9f9f9' }
          : { 'background-color': '#f9f9f9' },
      ]"
    >
      <div style="margin-left: 10px; margin-right: 10px">
        <div
          class="pt-8"
          style="
            font-size: 20px;
            margin-left: 1rem;
            margin-right: 1rem;
            color: #444444;
          "
        >
          Manage Quota Booking
          <v-icon size="30"> mdi-book-open-blank-variant </v-icon>
        </div>
        <v-card-text>
          <div>
            <v-card
              v-if="show"
              elevation="10"
              style="padding: 2%; margin-bottom: 2%"
            >
              <v-data-table
                :headers="headers"
                :items="roombookingList"
                hide-default-footer
                style="color: #332f2fde"
                :items-per-page="itemsPerPage"
                :page.sync="page"
                single-line
                hide-details
              >
                <template v-slot:item="{ item, index }">
                  <tr>
                    <td class="header-table-css">{{ no_run + (index + 1) }}</td>
                    <td class="header-table-css">{{ item.name }}</td>
                    <td class="header-table-css">{{ item.area.name }}</td>
                    <td class="header-table-css">{{ item.type }}</td>
                    <td class="header-table-css">
                      {{ ChangeFormatDate(item.createTime) }}
                    </td>
                    <td class="header-table-css">
                      {{ ChangeFormatDate(item.updateTime) }}
                    </td>
                    <td class="header-table-css">{{ item.lastUpdate }}</td>
                    <td
                      style="
                        padding-bottom: 5px;
                        display: flex;
                        flex-direction: column-reverse;
                        align-items: center;
                      "
                    >
                      <v-btn
                        :color="GetColor(item.enabled)"
                        rounded
                        class="text-capitalize"
                        depressed
                        style="width: 100px"
                      >
                        <span :style="{ color: GetColorText(item.enabled) }">{{
                          item.enabled == true ? "Active" : "InActive"
                        }}</span>
                      </v-btn>
                    </td>
                    <td style="text-align: center; min-width: 150px">
                      <v-btn
                        class="mx-2"
                        dark
                        small
                        color="orange"
                        @click="openDialog(item)"
                      >
                        Booking <v-icon dark> mdi-pencil-outline </v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>
              <br />
              <v-row class="mt-2">
                <v-col cols="12" md="4"></v-col>
                <v-col cols="12" md="3">
                  <v-pagination
                    v-model="page"
                    :total-visible="20"
                    :length="pageCount"
                    @input="ChangePage(page)"
                  ></v-pagination>
                </v-col>
                <v-col cols="12" md="3"></v-col>
                <v-col cols="12" md="2">
                  <v-autocomplete
                    solo
                    label="10/page"
                    v-model="itemsPerPage"
                    @input="ChangePerPage(itemsPerPage)"
                    :items="items"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card>
            <v-card
              v-else
              elevation="10"
              style="padding: 2%; margin-bottom: 2%"
            >
              <v-row>
                <v-col cols="12" sm="8" md="8" class="mt-2">
                  <div
                    style="
                      font-size: 20px;
                      margin-left: 1rem;
                      margin-right: 1rem;
                      color: #444444;
                    "
                  >
                    Booking
                    <v-icon size="30"> mdi-book-account-outline </v-icon>
                  </div>

                  <v-row>
                  <v-col cols="12" md="5" style="text-align: center">
                    <v-autocomplete
                      v-model="towerID"
                      :items="towerListArray"
                      hide-details
                      hide-selected
                      item-text="towerName"
                      item-value="towerID"
                      @change="getDataResidence()"
                    >
                    </v-autocomplete>
                  </v-col>
                </v-row>

                </v-col>

         

                <v-col cols="12" sm="4" md="4">
                  <template>
                    <v-row class="fill-height">
                      <v-col>
                        <v-sheet height="70">
                          <v-toolbar flat>
                            <v-btn
                              outlined
                              class="mr-4"
                              color="grey darken-2"
                              @click="setToday"
                            >
                              Today
                            </v-btn>
                            <v-btn
                              fab
                              text
                              small
                              color="grey darken-2"
                              @click="prev"
                            >
                              <v-icon small> mdi-chevron-left </v-icon>
                            </v-btn>
                            <v-btn
                              fab
                              text
                              small
                              color="grey darken-2"
                              @click="next"
                            >
                              <v-icon small> mdi-chevron-right </v-icon>
                            </v-btn>
                            <v-toolbar-title v-if="$refs.calendar">
                              {{ $refs.calendar.title }}
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-menu bottom right>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  outlined
                                  color="grey darken-2"
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  <span>{{ typeToLabel[type] }}</span>
                                  <v-icon right> mdi-menu-down </v-icon>
                                </v-btn>
                              </template>
                              <v-list>
                                <v-list-item @click="type = 'day'">
                                  <v-list-item-title>Day</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="type = 'week'">
                                  <v-list-item-title>Week</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="type = 'month'">
                                  <v-list-item-title>Month</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="type = '4day'">
                                  <v-list-item-title>4 days</v-list-item-title>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </v-toolbar>
                        </v-sheet>
                        <v-sheet height="600">
                          <v-calendar
                            ref="calendar"
                            v-model="focus"
                            color="primary"
                            :events="events"
                            :event-color="getEventColor"
                            :type="type"
                            @click:event="showEvent"
                            @click:more="viewDay"
                            @click:date="viewDay"
                            @change="updateRange"
                          ></v-calendar>
                          <v-menu
                            v-model="selectedOpen"
                            :close-on-content-click="false"
                            :activator="selectedElement"
                            offset-x
                          >
                            <v-card
                              color="grey lighten-4"
                              min-width="350px"
                              flat
                            >
                              <v-toolbar :color="selectedEvent.color" dark>
                                <v-btn icon>
                                  <v-icon>mdi-pencil</v-icon>
                                </v-btn>
                                <v-toolbar-title
                                  v-html="selectedEvent.name"
                                ></v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn icon>
                                  <v-icon>mdi-heart</v-icon>
                                </v-btn>
                                <v-btn icon>
                                  <v-icon>mdi-dots-vertical</v-icon>
                                </v-btn>
                              </v-toolbar>
                              <v-card-text>
                                <span v-html="selectedEvent.details"></span>
                              </v-card-text>
                              <v-card-actions>
                                <v-btn
                                  text
                                  color="secondary"
                                  @click="selectedOpen = false"
                                >
                                  Cancel
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-menu>
                        </v-sheet>
                      </v-col>
                    </v-row>
                  </template>
                </v-col>
              </v-row>
            </v-card>
          </div>
        </v-card-text>
      </div>
    </v-card>

    <v-dialog v-model="editDialog" persistent max-width="1100px">
      <v-card>
        <v-card-title style="background-color: black; color: white">
          <span class="text-h5">Room Booking</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col v-if="editStatus" cols="12" sm="2" md="2" class="mt-2">
                <v-text-field
                  label="Residence ID"
                  v-model="roombookingID"
                  type="number"
                  outlined
                  dense
                  disabled
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="4" class="mt-2">
                <v-text-field
                  label="Unit number*"
                  v-model="unitNumber"
                  :rules="[rules.required]"
                  ref="ref_unitNumber"
                  required
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="4" class="mt-2">
                <v-text-field
                  label="House No*"
                  v-model="houseId"
                  :rules="[rules.required]"
                  ref="ref_houseId"
                  required
                  outlined
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" md="4">
                <v-text-field
                  label="Remark*"
                  v-model="remark"
                  :rules="[rules.required]"
                  ref="ref_remark"
                  required
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <v-autocomplete
                  :items="TenantList"
                  item-text="tenantName"
                  item-value="tenantID"
                  label="Tenant"
                  v-model="TenantID"
                  required
                  clearable
                  outlined
                  dense
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="1" md="1" style="margin-top: -1%">
                <v-switch
                  v-model="activeSwitch"
                  hide-details
                  inset
                  :label="activeSwitch ? 'Active' : 'InActive'"
                ></v-switch>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <template>
                  <v-card class="mx-auto">
                    <v-card-title class="white--text primary darken-4">
                      Tower Name :
                      <v-spacer></v-spacer>
                      <v-autocomplete
                        v-model="towerNameList"
                        :items="towerListArray"
                        clearable
                        hide-details
                        hide-selected
                        item-text="towerName"
                        item-value="towerID"
                        solo
                        @change="getDataZoneAndFloorByTowerID()"
                      >
                      </v-autocomplete>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text
                      style="border: outset; width: unset; border-width: thick"
                    >
                      <table
                        v-if="zoneList.length > 0"
                        style="width: 100%; border-spacing: 0px"
                      >
                        <thead>
                          <tr>
                            <th
                              class="text-center"
                              style="
                                color: #000000;
                                background-color: orange;
                                width: 50px;
                                border-right: 1px solid;
                              "
                            >
                              ชั้น/โซน
                            </th>
                            <th
                              class="text-center"
                              style="
                                padding: 5px;
                                color: #000000;
                                background-color: skyblue;
                                border-right: 1px solid;
                              "
                              v-for="itemZ in zoneList"
                              :key="itemZ.id"
                            >
                              {{ itemZ.name }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="item in floorList" :key="item.id">
                            <td
                              style="
                                color: #000000;
                                text-align: center;
                                background-color: lightgray;
                                border-right: 1px solid;
                                height: 50px;
                                width: 30px;
                              "
                            >
                              {{ item.name }}
                            </td>
                            <td
                              v-for="items in zoneList"
                              :key="items.id"
                              style="border-right: 1px solid; width: 100px"
                            >
                              <div
                                style="
                                  display: flex;
                                  justify-content: center;
                                  align-items: center;
                                "
                              >
                                <v-checkbox
                                  :style="[
                                    ZoneWithFloor(item.id, items.id) == true
                                      ? { display: 'none' }
                                      : { display: 'grid' },
                                    { 'justify-content': 'space-around' },
                                  ]"
                                  v-model="checkbox"
                                  @click="
                                    checkboxClick(
                                      CheckBoxData(item.id, items.id)
                                    )
                                  "
                                  :value="CheckBoxData(item.id, items.id)"
                                ></v-checkbox>
                                <v-btn
                                  v-if="
                                    !ZoneWithFloor(item.id, items.id) &&
                                    !checkButton(
                                      CheckBoxData(item.id, items.id)
                                    )
                                  "
                                  @click="
                                    setDefaultFloor(
                                      CheckBoxData(item.id, items.id),
                                      true
                                    )
                                  "
                                  v-model="checkboxFloor"
                                  x-small
                                  style="
                                    cursor: pointer;
                                    color: gray;
                                    display: grid;
                                    justify-content: space-around;
                                  "
                                  >Default</v-btn
                                >

                                <v-btn
                                  v-if="
                                    !ZoneWithFloor(item.id, items.id) &&
                                    checkButton(CheckBoxData(item.id, items.id))
                                  "
                                  @click="
                                    setDefaultFloor(
                                      CheckBoxData(item.id, items.id),
                                      false
                                    )
                                  "
                                  v-model="checkboxFloor"
                                  x-small
                                  style="cursor: pointer; color: green"
                                  >Default</v-btn
                                >
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <th
                              class="text-center"
                              style="
                                color: #000000;
                                background-color: orange;
                                width: 50px;
                                border-right: 1px solid;
                              "
                            >
                              ชั้น/โซน
                            </th>
                            <th
                              class="text-center"
                              style="
                                padding: 5px;
                                color: #000000;
                                background-color: skyblue;
                                border-right: 1px solid;
                              "
                              v-for="itemZ in zoneList"
                              :key="itemZ.id"
                            >
                              {{ itemZ.name }}
                            </th>
                          </tr>
                        </tbody>
                      </table>
                    </v-card-text>
                  </v-card>
                </template>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-row>
            <v-col
              cols="12"
              sm="12"
              md="12"
              style="text-align: end; margin-bottom: 20px"
            >
              <v-spacer></v-spacer>
              <v-btn
                v-if="!editStatus"
                class="ma-2"
                style="min-width: 120px"
                color="success"
                @click="addResidence()"
              >
                Create
                <template v-slot:loader>
                  <span class="custom-loader">
                    <v-icon light>mdi-cached</v-icon>
                  </span>
                </template>
              </v-btn>
              <v-btn
                v-else
                class="ma-2"
                style="min-width: 120px"
                color="success"
                @click="updateResidence()"
              >
                Update
                <template v-slot:loader>
                  <span class="custom-loader">
                    <v-icon light>mdi-cached</v-icon>
                  </span>
                </template>
              </v-btn>
              <v-btn
                variant="outlined"
                color="silver"
                style="min-width: 120px"
                append-icon="mdi-close-circle-outline"
                @click="closeDialog()"
              >
                Close
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="selectTowerDialog" persistent max-width="1000">
      <v-card>
        <v-card-title class="text-h5">
          Use Google's location service?
        </v-card-title>

        <v-card-text>
          <div v-if="cards.length > 0">
            <carousel-3d
              :controls-visible="true"
              :clickable="false"
              :disable3d="!disable3d"
              :space="!disable3d ? 356 : 250"
              :width="340"
              :height="480"
              :border="1"
              style="border-radius: 10px"
            >
              <slide
                v-for="(card, i) in cards"
                :index="i"
                :key="card.description"
              >
                <figure
                  class="zoom"
                  style="
                    cursor: pointer;
                    background-color: aliceblue;
                    border-radius: 30px;
                  "
                >
                  <img
                    :src="card.src"
                    class="white--text align-end"
                    gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                    height="480px"
                    @click="
                      routerPage(
                        card.groupID == 5 || card.groupID == 6
                          ? card.description
                          : card.groupName
                      )
                    "
                  />
                  <figcaption>
                    {{
                      card.groupID == 5 || card.groupID == 6
                        ? card.description
                        : card.groupName
                    }}
                  </figcaption>
                </figure>
              </slide>
            </carousel-3d>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="loadingDialog" persistent width="auto">
      <div class="loading-box">
        <div class="inter-load">
          <div class="rect rect1"></div>
          <div class="rect rect2"></div>
          <div class="rect rect3"></div>
          <div class="rect rect4"></div>
          <div class="rect rect5"></div>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import enurl from "@/api/environment";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { eventBus } from "../../main";
import { Carousel3d, Slide } from "vue-carousel-3d";
// import { display } from "html2canvas/dist/types/css/property-descriptors/display";

export default {
  name: "Quota",
  components: {
    Carousel3d,
    Slide,
  },
  data() {
    return {
      url: enurl.apiUrl,
      permissionsPage: [],

      // Residence information
      startDate: "",
      endDate: "",
      search: null,
      activeSearch: null,
      menuStartDate: false,
      menuEndDate: false,
      activeSwitch: true,
      rules: { required: (value) => !!value || "Required." },
      roombookingList: [],
      roombookingID: null,
      unitNumber: null,
      houseId: null,
      remark: null,
      show: true,
      cards: [],

      // Tower information
      roombookingAuthFloorArray: [],
      towerListArray: [],
      defaultArray: [],
      towerNameList: "",
      getTowerZone: [],
      tenant: [],
      checkbox: [],
      checkboxFloor: [],
      locationMapping: [],
      locationFloorMap: [],
      towerList: [],
      towername: "",
      floorList: [],
      zoneList: [],
      defaultFloor: [],
      selectFloor: [],
      TenantList: [],
      TenantID: null,
      // Page information
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      items: [10, 15, 20, 50, 100],
      editDialog: false,
      editStatus: false,
      loadingDialog: false,

      focus: "",
      type: "day",
      typeToLabel: {
        month: "Month",
        week: "Week",
        day: "Day",
        "4day": "4 Days",
      },
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      events: [],
      colors: [
        "blue",
        "indigo",
        "deep-purple",
        "cyan",
        "green",
        "orange",
        "grey darken-1",
      ],
      names: [
        "Meeting",
        "Holiday",
        "PTO",
        "Travel",
        "Event",
        "Birthday",
        "Conference",
        "Party",
      ],

      selectTowerDialog: false,

      headers: [
        { text: "No", sortable: false, align: "left" },
        { text: "Name", sortable: false, align: "left" },
        { text: "Area Name", sortable: false, align: "left" },
        { text: "Type", sortable: false, align: "left" },
        { text: "CreateTime", sortable: false, align: "left" },
        { text: "updateTime", sortable: false, align: "left" },
        { text: "updateBy", sortable: false, align: "left" },
        { text: "Enabled", sortable: false, align: "center" },
        { text: "Action", sortable: false, align: "center" },
      ],
    };
  },
  mounted() {
    let Permision = localStorage.getItem("Permision");
    if (Permision == null || Permision == "") {
      this.$router.push("/Main");
    }
    let page = localStorage.getItem("page");
    this.permissionsPage = JSON.parse(Permision).find((x) => x.appName == page);

    this.getDataResidence();
    // this.getResidenceTowerList();
    this.GetRoleAuthFloors();
    this.getTenantResidenceList();
    // this.$refs.calendar.checkChange();
  },
  watch: {
    checkbox() {
      let self = this;
      if (self.defaultArray.find((a) => a.towerID == self.towerName) != null) {
        self.defaultArray.find((a) => a.towerID == self.towerName).selectFloor =
          self.checkbox;
      }
    },
  },
  methods: {
    viewDay({ date }) {
      this.focus = date;
      this.type = "day";
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = "";
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        requestAnimationFrame(() =>
          requestAnimationFrame(() => (this.selectedOpen = true))
        );
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        requestAnimationFrame(() => requestAnimationFrame(() => open()));
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    updateRange({ start, end }) {
      const events = [];

      const min = new Date(`${start.date}T00:00:00`);
      const max = new Date(`${end.date}T23:59:59`);
      const days = (max.getTime() - min.getTime()) / 86400000;
      const eventCount = this.rnd(days, days + 20);

      for (let i = 0; i < eventCount; i++) {
        const allDay = this.rnd(0, 3) === 0;
        const firstTimestamp = this.rnd(min.getTime(), max.getTime());
        const first = new Date(firstTimestamp - (firstTimestamp % 900000));
        const secondTimestamp = this.rnd(2, allDay ? 288 : 8) * 900000;
        const second = new Date(first.getTime() + secondTimestamp);

        events.push({
          name: this.names[this.rnd(0, this.names.length - 1)],
          start: first,
          end: second,
          color: this.colors[this.rnd(0, this.colors.length - 1)],
          timed: !allDay,
        });
      }

      this.events = events;
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },

    // Residence
    getDataResidence() {
      let self = this;
      self.loadingDialog = true;
      let temp = {
        page: self.page,
        limit: self.itemsPerPage,
        types: "room",
      };
      self.facility("Residence/authkey/facility", temp);
      self.loadingDialog = false;
    },
    SearchResidence(data) {
      let self = this;
      self.loadingDialog = true;
      let temp = {
        page: self.page,
        perpage: self.itemsPerPage,
        search: data,
        startDate: self.startDate,
        endDate: self.endDate,
        active:
          self.activeSearch == "Active"
            ? true
            : self.activeSearch == null
            ? null
            : false,
      };
      self.facility("Residence/authkey/facility", temp);
      self.loadingDialog = false;
    },
    addResidence() {
      let self = this;
      self.loadingDialog = true;
      let temp = {
        roombookingID: parseInt(self.roombookingID),
        unitNumber: self.unitNumber,
        houseId: self.houseId,
        remark: self.remark,
        active: self.activeSwitch,
        roombookingAuthFloorArray: self.defaultArray,
      };
      axios
        .post(`${self.url}Residence/addResidence`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            Swal.fire({
              icon: "success",
              title: "Success",
              showConfirmButton: false,
              timer: 1500,
            });
            self.getDataResidence();
            self.getTenantResidenceList();
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
        })
        .catch(function (error) {
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
      self.editDialog = false;
      self.loadingDialog = false;
    },
    updateResidence() {
      let self = this;
      self.loadingDialog = true;
      let temp = {
        roombookingID: parseInt(self.roombookingID),
        unitNumber: self.unitNumber,
        houseId: self.houseId,
        remark: self.remark,
        active: self.activeSwitch,
        roombookingAuthFloorArray: self.defaultArray,
        tenantID: self.TenantID,
      };
      axios
        .post(`${self.url}Residence/updateResidence`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            Swal.fire({
              icon: "success",
              title: "Success",
              showConfirmButton: false,
              timer: 1500,
            });
            self.loadingDialog = false;
            self.editDialog = false;
            self.getDataResidence();
            self.getTenantResidenceList();
          }
          self.loadingDialog = false;
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
        })
        .catch(function (error) {
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
      self.loadingDialog = false;
    },
    getResidenceByResidenceID(id) {
      let self = this;
      self.loadingDialog = true;
      let temp = {
        roombookingID: parseInt(id),
      };
      axios
        .post(`${self.url}Residence/getResidenceByResidenceID`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.bindingData(response.data.data);
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
          self.loadingDialog = false;
        })
        .catch(function (error) {
          if (error.response.status != 404) {
            self.loadingDialog = false;
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
    },
    bindingData(data) {
      let self = this;
      // console.log(data);
      self.towerNameList = "";
      self.floorList = [];
      self.zoneList = [];
      self.roombookingID = data.roombookingID;
      self.unitNumber = data.unitNumber;
      self.houseId = data.houseId;
      self.remark = data.remark;
      self.TenantID = data.tenantID;
      self.activeSwitch = data.active;
      for (let i = 0; i < self.getRoleAuthFloors.length; i++) {
        self.getRoleAuthFloors[i].choose = false;
        self.getRoleAuthFloors[i].defaultFloor = false;
      }

      self.defaultArray = [];
      self.towerListArray.forEach((element) => {
        let tempData = {
          towerID: element.towerID,
          selectFloor: [],
          defaultFloor: [],
        };
        self.defaultArray.push(tempData);
      });

      data.defaultArray.forEach((value) => {
        let item = self.defaultArray.find((x) => x.towerID == value.towerID);
        if (item != null) {
          self.defaultArray.find(
            (x) => x.towerID == value.towerID
          ).defaultFloor = value.defaultFloor;
          self.defaultArray.find(
            (x) => x.towerID == value.towerID
          ).selectFloor = value.selectFloor;
        }
      });
      self.towerNameList =
        data.defaultArray.length != 0 ? data.defaultArray[0].towerID : "";
      if (self.towerNameList != "") {
        self.getDataZoneAndFloorByTowerID();
      } else {
        self.loadingDialog = false;
      }
    },
    openDialog() {
      let self = this;
      // console.log(data);
      // self.$refs.calendar.checkChange();
      self.show = false;
    },
    closeDialog() {
      let self = this;
      self.editDialog = false;
      self.$refs.ref_unitNumber.reset();
      self.$refs.ref_houseId.reset();
      self.$refs.ref_remark.reset();
    },
    validateResidenceData() {
      if (
        this.unitNumber == "" ||
        this.unitNumber == null ||
        this.houseId == "" ||
        this.houseId == null
      ) {
        Swal.fire({
          icon: "warning",
          title: "กรุณากรอกข้อมูลให้ครบถ้วน",
          showConfirmButton: false,
          timer: 1500,
        });
        return false;
      } else {
        return true;
      }
    },

    // Tower, Floor and Zone setting
    getResidenceTowerList() {
      let self = this;
      self.loadingDialog = true;
      axios
        .get(`${self.url}Residence/getResidenceTowerList`)
        .then(function (response) {
          if (response.data.status == 0) {
            self.towerListArray = response.data.data;
            self.defaultArray = [];
            self.towerListArray.forEach((element) => {
              let tempData = {
                towerID: element.towerID,
                selectFloor: [],
                defaultFloor: [],
              };
              self.defaultArray.push(tempData);
            });
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
        })
        .catch(function (error) {
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
      self.loadingDialog = false;
    },

    getTenantResidenceList() {
      let self = this;
      self.loadingDialog = true;
      axios
        .get(`${self.url}Residence/getTenantResidenceList`)
        .then(function (response) {
          if (response.data.status == 0) {
            self.TenantList = response.data.data;
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
        })
        .catch(function (error) {
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
      self.loadingDialog = false;
    },

    getDataZoneAndFloorByTowerID() {
      let self = this;
      self.loadingDialog = true;
      if (self.towerNameList == null) {
        self.getTowerZone = [];
        return;
      }
      let temp = {
        towerID: self.towerNameList,
      };
      axios
        .post(`${self.url}Tenant/getDataZoneAndFloorByTowerID`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.checkbox = [];
            self.checkboxFloor = [];
            self.getTowerZone = response.data.data;
            self.locationMapping =
              self.getTowerZone.accessMapping.locationMapping;
            self.locationFloorMap =
              self.getTowerZone.accessMapping.locationFloorMap;
            self.towerName = self.getTowerZone.towerList.towerID;
            self.floorList = self.getTowerZone.towerList.floorList;
            self.zoneList = self.getTowerZone.towerList.zoneList;
            self.checkbox = self.defaultArray.find(
              (a) => a.towerID == self.towerName
            ).selectFloor;
            self.checkboxFloor = self.defaultArray.find(
              (a) => a.towerID == self.towerName
            ).defaultFloor;
            self.$forceUpdate();
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
          self.loadingDialog = false;
          self.editDialog = true;
        })
        .catch(function (error) {
          self.loadingDialog = false;
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
    },
    setDefaultFloor(value, checked) {
      let that = this;
      if (checked) {
        this.OneFloorInZone(value);
        if (that.checkbox.indexOf(value) != -1) {
          that.checkboxFloor.push(value);
        }
      } else {
        let index = that.checkboxFloor.indexOf(value);
        that.checkboxFloor.splice(index, 1);
      }
    },
    checkboxClick(value) {
      let that = this;

      that.checkboxFloor.forEach((x) => {
        if (that.checkbox.find((a) => a == x) == null) {
          let index = that.checkboxFloor.indexOf(value);
          that.checkboxFloor.splice(index, 1);
        }
      });
    },
    checkButton(value) {
      let that = this;
      let defaultFloor = that.checkboxFloor.find((x) => x == value);
      let selectFloor = that.checkbox.find((x) => x == value);
      if (defaultFloor != null && selectFloor != null) {
        return true;
      }

      return false;
    },
    CheckBoxData(floorID, zoneID) {
      let temp = "";
      let dataCheck = this.locationFloorMap.find(
        (x) => x.floorID == floorID && x.zoneID == zoneID
      );
      if (dataCheck != null) {
        temp = dataCheck.locationID;
        return temp;
      }
      return temp;
    },
    ZoneWithFloor(floorID, zoneID) {
      let dataCheck = this.locationFloorMap.find(
        (x) => x.floorID == floorID && x.zoneID == zoneID
      );
      if (dataCheck != null) {
        return false;
      }

      return true;
    },
    OneFloorInZone(value) {
      let that = this;
      let mainZoneID = this.locationMapping.find(
        (x) => x.locationID == value && x.towerID == this.towerName
      ).zoneID;

      let defaultData = this.defaultArray.find(
        (f) => f.towerID == this.towerName
      ).defaultFloor;

      defaultData.forEach((item) => {
        let findZoneDuplicate = this.locationMapping.find(
          (x) => x.locationID == item && x.towerID == this.towerName
        ).zoneID;
        if (mainZoneID == findZoneDuplicate) {
          if (that.checkbox.find((a) => a == value) != null) {
            let index = that.checkboxFloor.indexOf(item);
            that.checkboxFloor.splice(index, 1);
          }
        }
      });
    },
    GetRoleAuthFloors() {
      let that = this;
      that.loadingDialog = true;

      axios
        .get(`${that.url}Tenant/GetRoleAuthFloors`)
        .then(function (response) {
          if (response.data.status == 0) {
            that.getRoleAuthFloors = response.data.data;
            for (let i = 0; i < that.getRoleAuthFloors.length; i++) {
              that.getRoleAuthFloors[i].choose = false;
              that.getRoleAuthFloors[i].defaultFloor = false;
            }
            that.loadingDialog = false;
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
          that.loadingDialog = false;
        })
        .catch(function (error) {
          that.loadingDialog = false;
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
    },

    // Additional function
    ChangeFormatDate(date) {
      if (!date) return null;

      var DateData = new Date(date);
      var hours = DateData.getHours();
      var minutes = DateData.getMinutes();
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes;
      return (
        DateData.getDate() +
        "/" +
        (DateData.getMonth() + 1) +
        "/" +
        DateData.getFullYear() +
        "  " +
        strTime
      );
    },
    GetColor(value) {
      if (value == "1") {
        return "rgb(92, 184, 92,0.3)";
      } else {
        return "rgb(232, 34, 34,0.3)";
      }
    },
    GetColorText(value) {
      if (value == true) {
        return "rgb(92, 184, 92)";
      } else {
        return "rgb(232, 34, 34)";
      }
    },
    ChangePage(value) {
      let self = this;
      // self.loadingDialog = true;
      self.page = value;
      let temp = {
        page: value,
        perpage: self.itemsPerPage,
        search: self.search == null ? "" : self.search,
        startDate: self.startDate,
        endDate: self.endDate,
      };
      self.facility("Residence/authkey/facility", temp);
      // self.loadingDialog = false;
    },
    ChangePerPage(value) {
      let self = this;
      // self.loadingDialog = true;
      self.page = 1;
      let temp = {
        page: 1,
        perpage: value,
        search: self.search == null ? "" : self.search,
        startDate: self.startDate,
        endDate: self.endDate,
      };
      self.facility("Residence/authkey/facility", temp);
      // self.loadingDialog = false;
    },
    facility(databaseName, data) {
      let self = this;
      self.loadingDialog = true;
      axios
        .get(`${self.url}${databaseName}`, {
          params: { page: data.page, limit: data.limit, types: data.types },
        })
        .then(function (response) {
          // console.log(response);
          if (response.data.code == 200) {
            self.roombookingList = response.data.data.docs;

            self.pageCount = Math.ceil(
              response.data.data.totalDocs / self.itemsPerPage
            );
            self.no_run = (self.page - 1) * self.itemsPerPage;
            self.loadingDialog = false;
          } else {
            self.loadingDialog = false;
          }
        })
        .catch(function (error) {
          if (error.response.status != 404) {
            self.loadingDialog = false;
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
    },
  },
};
</script>

<style>
.v-data-table-header {
  background-color: black !important;
  color: #ffffff !important;
}
.v-data-table-header th {
  font-size: 14px !important;
  color: #ffffff !important;
}
.header-table-css {
  text-align: left;
  cursor: pointer;
}
</style>
